import { FromSchema, ZodDate, EnumSchema } from '@40seas/entities/common';
import { Country } from '@40seas/entities/common';
import { z } from 'zod';

export const PersonRoleSchema = z
    .object({
        name: z.string().optional(),
        startDate: ZodDate.optional(),
        endDate: ZodDate.optional(),
        isActive: z.boolean().optional(),
    })
    .strict();

export const PersonIdentitySchema = z
    .object({
        country: EnumSchema(Country).optional(),
        identityNumberType: z.string().optional(), // SSN9 SSN4 DRIVER_LICENSE PASSPORT NATIONAL_ID VOTER_ID BVN NIN NIN_SLIP SSNIT TAX_ID KENYA_KRA_PIN ALIEN_CARD RESIDENT_ID
        identityNumber: z.string().optional(),
        identityDocumentType: z.string().optional(), // 'PASSPORT' | 'DRIVER_LICENSE' | 'NATIONAL_ID' | 'PAN_CARD' | 'ID_CARD' | 'VOTER_ID_CARD' | 'RESIDENT_CARD' | 'GHANA_CARD' | 'GHANA_SSNIT_CARD' | 'KENYA_ALIEN_CARD'
    })
    .strict();

export const AiprizeRelatedPersonSchema = z
    .object({
        firstName: z.string().optional(),
        middleName: z.string().optional(),
        lastName: z.string().optional(),
        fullName: z.string().optional(),
        email: z.string().optional(),
        phone: z.string().optional(),
        title: z.string().optional(),
        address: z.string().optional(),
        city: z.string().optional(),
        dob: ZodDate.optional(),
        ownershipPercent: z.number().optional(),
        roles: z.array(PersonRoleSchema).optional(),
        identity: PersonIdentitySchema.optional(),
        gender: z.string().optional(),
    })
    .strict();

export class PersonRole extends FromSchema(PersonRoleSchema) {
    name?: string;
    startDate?: Date;
    endDate?: Date;
    isActive?: boolean;
}

export class PersonIdentity extends FromSchema(PersonIdentitySchema) {
    country?: Country;
    identityNumberType?: string;
    identityNumber?: string;
    identityDocumentType?: string;
}

export class AiprizeRelatedPerson extends FromSchema(AiprizeRelatedPersonSchema) {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    fullName?: string;
    email?: string;
    phone?: string;
    title?: string;
    address?: string;
    city?: string;
    dob?: Date;
    ownershipPercent?: number;
    roles?: PersonRole[];
    identity?: PersonIdentity;
}
